import React, { Component } from "react";
import DateRangePicker from "../../DateRangePicker";
import Dialog from "@material-ui/core/Dialog";
import format from "date-fns/format";
import CalenderIcon from "../icons/event_calendar.svg";
import "../styles/datePicker.scss";
export default class DatePicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCalender: false,
      localDateRange: null,
    };
  }

  toggleCalenderView = () => {
    this.setState((prevState) => ({ showCalender: !prevState.showCalender }));
  };
  componentDidMount() {
    this.setState({ localDateRange: this.props.dateRange });
  }
  render() {
    const disabled =
      this.state.localDateRange &&
      this.state.localDateRange[0].startDate ===
        this.props.dateRange[0].startDate &&
      this.state.localDateRange[0].endDate === this.props.dateRange[0].endDate;
    return (
      <div className="geo-filter-date-picker">
        <button onClick={this.toggleCalenderView}>
          <img src={CalenderIcon} />
          {`${format(
            this.props.dateRange[0].startDate,
            "dd MMMM, yyyy"
          )} - ${format(this.props.dateRange[0].endDate, "dd MMMM, yyyy")}`}
        </button>
        <Dialog
          open={this.state.showCalender}
          onClose={this.toggleCalenderView}
        >
          <div className="geo-filter-date-picker-inner-container">
            <DateRangePicker
              dateRange={this.state.localDateRange}
              onChangeDateRange={(item) => {
                this.setState({ localDateRange: [item.selection] });
              }}
            />
            <button
              className="apply-dates"
              disabled={disabled}
              onClick={() => {
                this.props.onChangeDateRange({
                  selection: { ...this.state.localDateRange[0] },
                });
                this.toggleCalenderView();
              }}
            >
              Apply Dates
            </button>
          </div>
        </Dialog>
      </div>
    );
  }
}
